
import SignaturePad from 'signature_pad';

let signPad;

export default {
    props: {
        remote: Boolean,
        token: String,
        caseId: Number,
        type: String,
        amendmentIndex: Number,
        signedByRef: Number,
        previewOnly: Boolean,
    },

    data() {
        return {
            docHtml: null,
            docType: null,
            loaded: false,
            signed: false,
            isAlreadySigned: false,
            isTokenBad: false,
        };
    },

    methods: {
        async confirm() {
            const dataUri = signPad.toDataURL();
            const signature = this.dataUriToBlob(dataUri);
            const formData = new FormData();

            if (this.remote) {
                formData.append('token', this.token);
            } else {
                formData.append('data', JSON.stringify({
                    caseId: this.caseId,
                    type: this.type,
                    amendmentIndex: this.amendmentIndex,
                    signedByRef: this.signedByRef,
                }));
            }

            formData.append('signature', signature);

            try {
                await axios.create().post('/doc/sign', formData);

                this.signed = true;

                notifyOk("Podepsání proběhlo úspěšně.");
            } catch (err) {
                const key = err.response?.data?.key;

                if (key === 'doc.sign.alreadySigned') {
                    this.isAlreadySigned = true;
                } else if (key === 'doc.sign.expiredToken') {
                    this.isTokenBad = true;
                } else {
                    debug.error(err, err.response?.data);

                    this.isTokenBad = true;
                }
            }
        },
        reset() {
            signPad.clear();
        },
        dataUriToBlob(dataUri) {
            // Convert base64/URL-encoded data component to raw binary data held in a string
            let byteString;

            if (dataUri.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataUri.split(',')[1]);
            } else {
                byteString = unescape(dataUri.split(',')[1]);
            }

            // Separate out the mime component
            var mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

            // Write the bytes of the string to a typed array
            let ia = new Uint8Array(byteString.length);

            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        },
        processHtml(html) {
            return html
                // Replace full images with thumbs
                .replace(/<img src="([^{"]+)"/g, '<img src="$1&thumb=true"')
                // Reference logo from public folder
                .replace(/\{\{ *assetsPath *\}\}\/img/, '');
        },
    },

    async mounted() {
        try {
            const { data } = await axios.create().post('/doc/info', this.remote ? {
                token: this.token,
            } : {
                caseId: this.caseId,
                type: this.type,
                amendmentIndex: this.amendmentIndex,
            });

            const { type, html } = data;

            this.docType = type;
            this.docHtml = this.processHtml(html);

            if (!this.previewOnly) {
                signPad = new SignaturePad(this.$refs.canvas);
            }

            this.loaded = true;
        } catch (err) {
            const key = err.response?.data?.key;

            if (key === 'doc.info.alreadySigned') {
                this.isAlreadySigned = true;
            } else if (key === 'doc.info.invalidSignToken') {
                this.isTokenBad = true;
            } else {
                debug.error(err, err.response?.data);

                this.isTokenBad = true;
            }
        }
    },
};
